// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Creator-module__date___VhxwW{white-space:nowrap;color:hsla(0,0%,100%,.5)}", "",{"version":3,"sources":["webpack://./src/components/search/Spark/LeftMeta/Creator/Creator.module.scss"],"names":[],"mappings":"AAAA,8BACE,kBAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": "Creator-module__date___VhxwW"
};
export default ___CSS_LOADER_EXPORT___;
